import { baseApi } from './baseApi';

/**
 * Materials API endpoints
 * Handles CRUD operations for material management
 */
export const materialsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /materials - Fetch all materials
    getMaterials: builder.query({
      query: () => '/materials',
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Material', id })),
              { type: 'Material', id: 'LIST' },
            ]
          : [{ type: 'Material', id: 'LIST' }],
    }),

    // GET /materials/search - Search materials
    searchMaterials: builder.query({
      query: (searchQuery) => `/materials/search?q=${encodeURIComponent(searchQuery)}`,
      providesTags: [{ type: 'Material', id: 'SEARCH' }],
    }),

    // POST /materials - Create new material
    createMaterial: builder.mutation({
      query: (materialData) => ({
        url: '/materials',
        method: 'POST',
        body: materialData,
      }),
      invalidatesTags: [{ type: 'Material', id: 'LIST' }],
    }),

    // PATCH /materials/:id - Update material
    updateMaterial: builder.mutation({
      query: ({ id, ...materialData }) => ({
        url: `/materials/${id}`,
        method: 'PATCH',
        body: materialData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Material', id },
        { type: 'Material', id: 'LIST' },
      ],
    }),

    // DELETE /materials/:id - Delete material
    deleteMaterial: builder.mutation({
      query: (id) => ({
        url: `/materials/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Material', id },
        { type: 'Material', id: 'LIST' },
      ],
    }),

    // GET /materials/:materialId/images - Get material images
    getMaterialImages: builder.query({
      query: (materialId) => `/materials/${materialId}/images`,
      providesTags: (result, error, materialId) => [{ type: 'MaterialImage', id: materialId }],
    }),

    // POST /materials/:materialId/images - Upload material image
    uploadMaterialImage: builder.mutation({
      query: ({ materialId, formData }) => ({
        url: `/materials/${materialId}/images`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: (result, error, { materialId }) => [
        { type: 'MaterialImage', id: materialId },
        { type: 'Material', id: materialId },
      ],
    }),

    // DELETE /materials/images/:imageId - Delete material image
    deleteMaterialImage: builder.mutation({
      query: (imageId) => ({
        url: `/materials/images/${imageId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'MaterialImage' }, { type: 'Material', id: 'LIST' }],
    }),
  }),
});

// Export hooks for use in components
export const {
  useGetMaterialsQuery,
  useSearchMaterialsQuery,
  useCreateMaterialMutation,
  useUpdateMaterialMutation,
  useDeleteMaterialMutation,
  useGetMaterialImagesQuery,
  useUploadMaterialImageMutation,
  useDeleteMaterialImageMutation,
} = materialsApi;

